<bb-modal-ui class="sessionModal"
  [isOpen]="isOpen"
  [modalOptions]="modalOptions">
  <div class="modal-header">
    <h4 class="modal-title"
      i18n="@@bn-session-timeout-title">
      Session Time Out
    </h4>
  </div>
  <div class="modal-body session-timeout-text">
    <span i18n="@@bn-session-timeout-text1">Due to inactivity, your session will time out in</span> {{timeRemaining}}
    <span i18n="@@bn-session-timeout-text2">seconds.</span>
    <div class="session-timeout-text__bottom"></div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary"
      i18n="@@bn-session-timeout-button-close"
      (click)="logout()">Logout</button>
    <button class="btn btn-primary btn-logged-in"
      i18n="@@bn-session-timeout-button-continue"
      (click)="refresh()">Continue logged in</button>
  </div>
</bb-modal-ui>
